import { OTE_TEST_USER_EMAIL_PREFIX } from '@oup/shared-node-browser/constants';

export default function isTestingUser(email) {
  const testingEmails = OTE_TEST_USER_EMAIL_PREFIX.split(',');
  return testingEmails.some(testingEmail => email.startsWith(testingEmail));
}
